import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsFacade, abbreviateCountryStr, customDecode, decrypt } from '@piqet-angular/data';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  DISTANCE_KM_LABEL,
  grid_widths_map,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { ColDef } from 'ag-grid-community';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { NumericCellEditor } from 'libs/ui/src/lib/numeri-cell-editor/numeric-cell-editor.component';
import { cloneDeep } from 'lodash';
import { Subject, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectScenarioFillingDataGridService {
  projectFillingPayload: any;
  event: any;

  deleteFilling = new Subject<[any]>();
  deleteFillingData$ = this.deleteFilling.asObservable();

  editFillingSuccess = new Subject<any>();
  editFillingSuccessData$ = this.editFillingSuccess.asObservable();

  editProjectFillSub = new Subject<[any, any]>();
  editProjectFillSubData$ = this.editProjectFillSub.asObservable();

  editProjectFillSubProduct = new Subject<[any, any]>();
  editProjectFillSubProductData$ = this.editProjectFillSubProduct.asObservable();

  checkDeleteRowFill = new Subject<[any, any, boolean]>();
  checkDeleteRowFillData$ = this.checkDeleteRowFill.asObservable();
  allTransportLocationRecords: any;

  checkDeleteRowFillProduct = new Subject<[any, any, boolean]>();
  checkDeleteRowFillDataProduct$ = this.checkDeleteRowFillProduct.asObservable();

  saveProjectManualDistanceWholesaleFilling = new Subject<[any, any]>();
  saveProjectManualDistanceWholesaleFillingData$ =
    this.saveProjectManualDistanceWholesaleFilling.asObservable();

  clearInputFieldProjectManualDistanceFilling = new Subject<any>();
  clearInputFieldProjectManualDistanceFillingData$ =
    this.clearInputFieldProjectManualDistanceFilling.asObservable();

  //product
  saveProjectManualDistanceWholesaleFillingProduct = new Subject<[any, any]>();
  saveProjectManualDistanceWholesaleFillingProductData$ =
    this.saveProjectManualDistanceWholesaleFillingProduct.asObservable();

  clearInputFieldProjectManualDistanceFillingProduct = new Subject<any>();
  clearInputFieldProjectManualDistanceFillingProduct$ =
    this.clearInputFieldProjectManualDistanceFillingProduct.asObservable();

  allTransportLocationRecordsProduct: any;

  constructor(
    private projectsFacade: ProjectsFacade,
    private accessService: AccessPermissionService,
    private swalService: SwalService,
    public route: ActivatedRoute,
    private projectFacade: ProjectsFacade
  ) {}

  projectFillingColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'FillingName',
      headerName: 'Filling process',
      field: 'fillingName',
      minWidth: grid_widths_map.sm_column_xl,
      cellStyle: { 'text-decoration': 'underline' },
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          const url = location.href.split('/');
          let projectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
          let packageScenarioId;
          this.route.queryParams.subscribe((values: any) => {
            let value: any = decrypt(values.param ? values.param : '');
            value = value && !value.includes('undefined') ? JSON.parse(value) : '';
            packageScenarioId = value['packageScenarioId'];
          });
          this.projectsFacade.openNewAddProjectFillData(
            packageScenarioId,
            params.data.id,
            'Review filling',
            projectId
          );
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'PercentageProductLoss',
      headerName: 'Product loss in filling %',
      field: 'percentageProductLoss',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      cellRenderer: 'linkRenderer',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'WasteDisposalIdentifierName',
      headerName: 'Destination of product loss',
      field: 'wasteDisposalIdentifierName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        cellRendererParams: {
          showDelete: true,
          showEdit: true,
          deleteData: (data: any) => {
            this.deleteConfirmation(data);
          },
          editData: (data: any) => {
            const url = location.href.split('/');
            let projectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
            let scenarioId;
            this.route.queryParams.subscribe((values: any) => {
              let value: any = decrypt(values.param ? values.param : '');
              value = value && !value.includes('undefined') ? JSON.parse(value) : '';
              scenarioId = value['packageScenarioId'];
            });

            this.projectsFacade.openNewAddProjectFillData(
              scenarioId,
              data.id,
              'Review filling',
              projectId
            );
          },
        },
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });
    return colDef;
  }

  projectFillingColumnWithComponent(allItemsAreComponents: boolean): ColDef[] {
    const colDef: ColDef[] = [];

    !allItemsAreComponents &&
      colDef.push({
        ...defaultColumn,
        colId: 'Header',
        headerName: '',
        field: 'header',
        cellClass: 'my-permission-cursor-pointer',
        lockPosition: true,
        maxWidth: grid_widths_map.icon_lg,
        resizable: false,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        wrapText: true,
        sortable: false,
        cellRenderer: (params: any) => {
          const cellDiv = document.createElement('div');
          cellDiv.style.display = 'grid';
          cellDiv.style.gridTemplateColumns = '1fr';

          // Conditionally create and append the image if isComponent is false
          if (!params.data.isComponent) {
            const imgElement = document.createElement('img');
            imgElement.style.cursor = 'pointer';
            imgElement.src = './assets/icons/Product-Sidebar-Icon.svg';
            imgElement.alt = 'Product';
            imgElement.title = 'Product';
            imgElement.style.width = '25px';
            imgElement.style.height = '25px';
            imgElement.style.marginTop = '0.15rem';
            cellDiv.appendChild(imgElement);
          }

          return cellDiv;
        },
      });

    colDef.push({
      ...defaultColumn,
      colId: 'ComponentName',
      headerName: 'Name',
      field: 'componentName',
      suppressColumnsToolPanel: true,
      cellStyle: { 'text-decoration': 'underline' },
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          const url = location.href.split('/');
          let projectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
          let packageScenarioId;
          this.route.queryParams.subscribe((values: any) => {
            let value: any = decrypt(values.param ? values.param : '');
            value = value && !value.includes('undefined') ? JSON.parse(value) : '';
            packageScenarioId = value['packageScenarioId'];
          });
          this.projectsFacade.openNewAddProjectFillData(
            packageScenarioId,
            params.data.id,
            'Review filling',
            projectId
          );
        });
        return cellElement;
      },
    });
    colDef.push({
      ...defaultColumn,
      colId: 'Transport',
      headerName: 'Transport',
      field: 'transport',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'iconsOfTransport',
      lockPosition: true,
      autoHeight: true,
      resizable: false,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: true,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'FillingName',
      headerName: 'Filling process',
      field: 'fillingName',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: false,
      autoHeight: true,
      lockPosition: true,
      resizable: false,
      cellRenderer: (params: any) => {
        const cellDiv = document.createElement('div');
        cellDiv.style.display = 'grid';
        cellDiv.style.gridTemplateColumns = '1fr';
        params.data?.fillingProcessData?.forEach((data: any) => {
          const cellValue = data.fillingName;
          const cellElement = document.createElement('span');

          cellElement.innerHTML = `${cellValue}`;
          cellElement.style.whiteSpace = 'nowrap';
          cellElement.style.overflow = 'hidden';
          cellElement.style.textOverflow = 'ellipsis';
          cellElement.style.display = 'block';
          cellElement.title = cellValue;

          cellDiv.appendChild(cellElement);
          cellDiv.appendChild(document.createElement('br'));
        });
        return cellDiv;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'PercentageProductLoss',
      headerName: 'Product loss in filling %',
      field: 'percentageProductLoss',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: false,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      cellRenderer: (params: any) => {
        const cellDiv = document.createElement('div');
        cellDiv.style.display = 'grid';
        cellDiv.style.gridTemplateColumns = '1fr';
        params.data?.fillingProcessData?.forEach((data: any) => {
          const cellValue = data.percentageProductLoss;
          const cellElement = document.createElement('span');

          cellElement.innerHTML = `${cellValue}`;
          cellElement.style.whiteSpace = 'nowrap';
          cellElement.style.overflow = 'hidden';
          cellElement.style.textOverflow = 'ellipsis';
          cellElement.style.display = 'block';
          cellElement.title = cellValue;

          cellDiv.appendChild(cellElement);
          cellDiv.appendChild(document.createElement('br'));
        });
        return cellDiv;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'WasteDisposalIdentifierName',
      headerName: 'Destination of product loss',
      field: 'wasteDisposalIdentifierName',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: false,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      cellRenderer: (params: any) => {
        const cellDiv = document.createElement('div');
        cellDiv.style.display = 'grid';
        cellDiv.style.gridTemplateColumns = '1fr';
        params.data?.fillingProcessData?.forEach((data: any) => {
          const cellValue = data.wasteDisposalIdentifierName;
          const cellElement = document.createElement('span');

          cellElement.innerHTML = `${cellValue}`;
          cellElement.style.whiteSpace = 'nowrap';
          cellElement.style.overflow = 'hidden';
          cellElement.style.textOverflow = 'ellipsis';
          cellElement.style.display = 'block';
          cellElement.title = cellValue;

          cellDiv.appendChild(cellElement);
          cellDiv.appendChild(document.createElement('br'));
        });
        return cellDiv;
      },
    });

    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        cellRendererParams: {
          showDelete: true,
          showEdit: true,
          deleteData: (data: any) => {
            this.deleteConfirmation(data);
          },
          editData: (data: any) => {
            const url = location.href.split('/');
            let projectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
            let scenarioId;
            this.route.queryParams.subscribe((values: any) => {
              let value: any = decrypt(values.param ? values.param : '');
              value = value && !value.includes('undefined') ? JSON.parse(value) : '';
              scenarioId = value['packageScenarioId'];
            });

            this.projectsFacade.openNewAddProjectFillData(
              scenarioId,
              data.id,
              'Review filling',
              projectId
            );
          },
        },
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });
    return colDef;
  }

  fillingProcessColumn(): ColDef[] {
    // For filling process section inside add Modal
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'FillingProcessName',
      headerName: 'Filling process name',
      field: 'fillingProcessName',
      minWidth: grid_widths_map.sm_column_xl,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridMyProjectImageComponent',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Amount',
      headerName: 'Amount',
      field: 'amount',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      cellRenderer: 'linkRenderer',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'CostPerUnit',
      headerName: 'Cost per unit',
      field: 'costPerUnit',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'CostPerPackage',
      headerName: 'Cost per package',
      field: 'costPerPackage',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showDelete: true,
        deleteData: (data: any) => {
          this.projectsFacade.fillingProcessActions(data, 'delete');
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  locationColumn(): ColDef[] {
    // For filling process section inside add Modal
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'Location',
      headerName: 'Location',
      field: 'location',
      minWidth: grid_widths_map.sm_column_xl,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridMyProjectImageComponent',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      cellRenderer: 'linkRenderer',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'PersanteageMassLoad',
      headerName: 'Load efficiency',
      field: 'persanteageMassLoad',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      // cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: true,
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'Distance') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },
      cellEditorParams: {
        isCheckTransportDistance: true,
        from: 'project-pages-inline',
      },
      cellClass: ['outerGridEdit', 'outerGridProjectEdit', 'elipsisFields'],
      cellStyle: params => {
        const isCellEditable = params.rowIndex == 0 ? false : true;
        return {
          'pointer-events': isCellEditable ? '' : 'none',
        };
      },
      valueSetter: (params: any) => {
        const oldValue = params.data[params.colDef.field];
        const getDisType = oldValue.substring(oldValue.indexOf(' ') + 1);
        const newVal = params.newValue + ' ' + (getDisType == '0' ? ' ' : getDisType);
        const valueChanged = params.data[params.colDef.field] !== newVal;
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.projectFacade.locationProcessActions(params.data, 'edit');
          this.editProjectFillSub.next([params.data, false]);
          return valueChanged;
        } else {
          return oldValue;
        }
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showInlineEdit: true,
        showInlineDelete: true,
        from: 'projectPages',
        editDataInline: (data: any, pathName: any) => {
          data.isCheckManualDis
            ? this.projectFacade.distanceTransportActions(data, 'edit', true)
            : this.projectFacade.locationProcessActions(data, 'edit');
          this.editProjectFillSub.next([data, true]);
        },
        deleteInlineGrid: (data: any) => {
          if (!!data?.isDistance) {
            this.alertConfirmationForManualDistance(data);
          } else {
            this.alertConfirmationForManualLocation(data);
          }
        },
        saveDataInline: (data: any) => {
          this.saveProjectManualDistanceWholesaleFilling.next([data, 'manualLocation']);
        },
        clearInputField: (data: any) => {
          this.clearInputFieldProjectManualDistanceFilling.next(data);
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'inlineActionButtonComponent',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  locationColumnProduct(): ColDef[] {
    // For filling process section inside add Modal
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'OriginName',
      headerName: 'Location',
      field: 'originName',
      minWidth: grid_widths_map.sm_column_xl,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridMyProjectImageComponent',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      cellRenderer: 'linkRenderer',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'PersanteageMassLoad',
      headerName: 'Load efficiency',
      field: 'persanteageMassLoad',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      // cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: true,
      cellStyle: params => {
        const isCellEditable = params.rowIndex == 0 ? false : true;
        return {
          'pointer-events': isCellEditable ? '' : 'none',
        };
      },
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'Distance') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },
      cellEditorParams: {
        isCheckTransportDistance: true,
        from: 'project-pages-inline',
      },
      cellClass: ['outerGridEdit', 'outerGridProjectEdit', 'elipsisFields'],
      valueSetter: (params: any) => {
        const oldValue = params.data[params.colDef.field];
        const getDisType = oldValue.substring(oldValue.indexOf(' ') + 1);
        const newVal = params.newValue + ' ' + (getDisType == '0' ? ' ' : getDisType);
        const valueChanged = params.data[params.colDef.field] !== newVal;
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.projectFacade.locationProductProcessActions(params.data, 'edit');
          this.editProjectFillSubProduct.next([params.data, false]);
          return valueChanged;
        } else {
          return oldValue;
        }
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showInlineEdit: true,
        showInlineDelete: true,
        from: 'projectPages',
        editDataInline: (data: any, pathName: any) => {
          this.editProjectFillSubProduct.next([data, true]);
        },
        deleteInlineGrid: (data: any) => {
          if (!!data?.isDistance) {
            this.alertConfirmationForManualDistanceProduct(data);
          } else {
            this.alertConfirmationForManualLocationProduct(data);
          }
        },
        saveDataInline: (data: any) => {
          this.saveProjectManualDistanceWholesaleFillingProduct.next([data, 'manualLocation']);
        },
        clearInputField: (data: any) => {
          this.clearInputFieldProjectManualDistanceFillingProduct.next(data);
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'inlineActionButtonComponent',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  customSiteTransportColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'CityName',
      headerName: 'Origin-destination',
      field: 'cityName',
      minWidth: grid_widths_map.sm_column_xl,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridMyProjectImageComponent',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      cellRenderer: 'linkRenderer',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    return colDef;
  }

  addComponentColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'ComponentName',
      headerName: 'Component',
      field: 'componentName',
      minWidth: grid_widths_map.sm_column_xl,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridMyProjectImageComponent',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'iconsOfTransport',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showDelete: true,
        deleteData: (data: any) => {
          this.deleteConfirmation(data, 'component');
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });

    return colDef;
  }
  addProductColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'ProductName',
      headerName: 'Product',
      field: 'productName',
      minWidth: grid_widths_map.sm_column_xl,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'iconsOfTransport',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showDelete: true,
        deleteData: (data: any) => {
          this.deleteConfirmation(data, 'product');
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });

    return colDef;
  }

  alertConfirmationForManualLocation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectFacade.locationProcessData$.pipe(take(1)).subscribe((records: any) => {
          this.allTransportLocationRecords = records;
        });
        this.projectsFacade.locationProcessActions(data, 'delete');
        this.checkDeleteRowFill.next([this.allTransportLocationRecords, data, true]);
      }
    });
  }

  alertConfirmationForManualDistance(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectsFacade.distanceTransportActions(data, 'delete');
        this.checkDeleteRowFill.next([undefined, data, false]);
      }
    });
  }

  alertConfirmationForManualDistanceProduct(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectsFacade.distanceTransportProductActions(data, 'delete');
        this.checkDeleteRowFillProduct.next([undefined, data, false]);
      }
    });
  }

  alertConfirmationForManualLocationProduct(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectFacade.locationProcessProductData$.pipe(take(1)).subscribe((records: any) => {
          this.allTransportLocationRecordsProduct = records;
        });
        this.projectsFacade.locationProductProcessActions(data, 'delete');
        this.checkDeleteRowFillProduct.next([this.allTransportLocationRecordsProduct, data, true]);
      }
    });
  }

  deleteConfirmation(data: any, type?: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed && type != 'component' && type != 'product') {
        this.deleteFilling.next([data]);
      } else if (confirmed && type == 'component') {
        this.projectsFacade.componentTransportActions(data, 'delete');
      } else if (confirmed && type == 'product') {
        this.projectsFacade.productTransportActions(data, 'delete');
      }
    });
  }

  getFillingDataList() {
    this.editFillingSuccess.next(() => {});
  }

  isEmpty(val: any) {
    if (val !== undefined || val !== null || val !== '') {
      val = val.trim();
    }
    return val === undefined || val === null || val === '';
  }

  accessPermission(): boolean {
    return this.accessService.hasPermission('edit', '', 'packaging');
  }
}
